import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted, computed, ref } from 'vue';
import Http from '@/core/http/http.service';
import { WebRequestEnum } from '@/ui/views/product-details/variant-download/DownloadSelection.vue';
import { Key } from '@/core/keycodes';

import { store } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'VariantDragUldFiles',
  props: {
    providedVariantId: null
  },
  setup(__props: any) {

const props = __props as {providedVariantId?: string}



const selectedLanguage = computed<MarketViewObject>(() => store.getters['app/selectedLanguage']);
const selectedConfigVariant = computed<ProfessionalVariantViewObject>(() => store.getters['catalog/selectedConfigVariant']);

const multipleFileDragOpen = ref<boolean>(false);
let uldFiles: Vertica.LouisPoulsen.Application.Content.Pages.Product.Download.FileViewObject[] = [];

onMounted(() => {
    initUldFiles();
    document.addEventListener('keydown', closeMultipleFileDragOnEsc);
});

onUnmounted(() => {
    document.removeEventListener('keydown', closeMultipleFileDragOnEsc);
});

function initUldFiles() {
    const requestUrl = WebRequestEnum.VariantFilesByType;
    const requestParams: Vertica.LouisPoulsen.Application.Content.Api.VariarntFilesByTypeWebRequest = {
        variantId: props.providedVariantId || selectedConfigVariant.value.id,
        type: 'uld'
    };

    Http.get(`/downloadcenter/${requestUrl}`, requestParams).then((data: Vertica.LouisPoulsen.Application.Content.Pages.Product.Download.FileViewObject[]) => {
        uldFiles = data;
    });
}

function closeMultipleFileDragOnEsc(event: KeyboardEvent) {
    if (event.keyCode === Key.ESC && this.closeMultipleFileDrag) {
        closeMultipleFileDrag();
    }
}
function getSingleFileUrl(id: string): string {
    // write a url that matches the UldFile rewriting rule
    // output example: dial://lp.com/da-dk/uld-download/90787-5747834110-01_249781__19768.uld
    const hostname = window.location.hostname;
    return encodeURI(`dial://${hostname}/${selectedLanguage.value.code}/uld-download/${id}.uld`);
}

function toggleMultipleFileDrag(): void {
    multipleFileDragOpen.value = !multipleFileDragOpen.value;
}

function closeMultipleFileDrag(): void {
    multipleFileDragOpen.value = false;
}


return { __sfc: true,props, selectedLanguage, selectedConfigVariant, multipleFileDragOpen, uldFiles, initUldFiles, closeMultipleFileDragOnEsc, getSingleFileUrl, toggleMultipleFileDrag, closeMultipleFileDrag }
}

})